import AccueilPage from './screen/AccueilPage';

const App = () => {
  return <AccueilPage />;
};

export default App;
